import { render, staticRenderFns } from "./CoursesDialogWrapper.vue?vue&type=template&id=1b28573a&scoped=true"
import script from "./CoursesDialogWrapper.vue?vue&type=script&lang=js"
export * from "./CoursesDialogWrapper.vue?vue&type=script&lang=js"
import style0 from "./CoursesDialogWrapper.vue?vue&type=style&index=0&id=1b28573a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b28573a",
  null
  
)

export default component.exports